module.exports = __webpack_public_path__ + "static/media/heart_shape_earth.9a8e73f6.png";